/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DisplayNameDto
 */
export interface DisplayNameDto {
    /**
     * 
     * @type {number}
     * @memberof DisplayNameDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof DisplayNameDto
     */
    text?: string | null;
}

/**
 * Check if a given object implements the DisplayNameDto interface.
 */
export function instanceOfDisplayNameDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DisplayNameDtoFromJSON(json: any): DisplayNameDto {
    return DisplayNameDtoFromJSONTyped(json, false);
}

export function DisplayNameDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DisplayNameDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'text': !exists(json, 'text') ? undefined : json['text'],
    };
}

export function DisplayNameDtoToJSON(value?: DisplayNameDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'text': value.text,
    };
}

